<template>
	<div id="ZCcunliangzichanxingzhizhanbi" style="width: 100%;height:100%;" ref="ZCcunliangzichanxingzhizhanbi"></div>
</template>

<script>
	import * as echarts from "echarts";
	import apis from "@/http/apis";
	import chartClickMixin from "@/views/index/components/handlemixin.js"; // 引入混合

	// 解码后端返回的 \uXXXX 字面量字符串
	function decodeUnicode(str) {
		if (typeof str !== 'string') return str;
		return str.replace(/\\u([0-9a-fA-F]{4})/g, (_, code) => String.fromCharCode(parseInt(code, 16)));
	}

	export default {
		// 使用混合
		mixins: [chartClickMixin],
		name: 'StockAssetNatureBarChart',
		
		// 组件传参，拿到父组件传递的数据
		props: {
			greenTraffic: {
				default () {
					return [];
				},
			},
			// 添加图表名称属性
			chartName: {
				type: String,
				default: '存量资产性质占比'
			}
		},
		data() {
			return {
				arrX: [],
				arrY: [],
				chartType: 'bar' // 指定图表类型
			};
		},
		watch: {
			// 侦听父组件的数据，发生变化后处理数据后重新渲染dom
			greenTraffic: {
				handler(val) {
					this.arrX = [];
					this.arrY = [];
					if (Array.isArray(val) && val.length) {
						val.forEach((item) => {
							this.arrX.push(item.trafficKey);
							this.arrY.push((Number(item.trafficValue) / 10000).toFixed(2));
						});
					}
					this.drawFftjChart();
				},
				deep: true,
			},
		},
		created() {
			this.apidata();
		},
		methods: {
			// 重写混合中的初始化方法
			initChartWithClick() {
				// 这个方法的实现在drawFftjChart中
			},
			
			apidata() {
				apis.stockAssetNature().then((res) => {
					console.log('[存量资产性质占比] 接口返回数据:', res);
					const list = res && res.data && res.data.list ? res.data.list : [];
					if (list.length) {
						this.arrX = list.map(item => decodeUnicode(item.name));
						this.arrY = list.map(item => item.value);
					}
					this.drawFftjChart();
				}).catch(() => {
					this.drawFftjChart();
				});
			},
			drawFftjChart() {
				let yData = this.arrY;
				// 使用ref获取DOM元素，而不是document.getElementById
				var ZCcunliangzichanxingzhizhanbi = echarts.init(this.$refs.ZCcunliangzichanxingzhizhanbi || document.getElementById("ZCcunliangzichanxingzhizhanbi"));
				
				// 准备柱状图的数据格式
				const chartData = this.arrX.map((name, index) => {
					return {
						name: name,
						value: yData[index] || 0,
						// 可以添加更多自定义属性
						itemStyle: {
							color: this.getColorByIndex(index)
						}
					};
				});
				
				const option = {
					grid: {
						left: "2%",
						right: "2%",
						top: "5%",
						bottom: "2%",
						width: "90%",
						height: "90%",
						containLabel: true,
					},
					tooltip: {
						trigger: "axis",
						axisPointer: {
							type: "shadow"
						},
						formatter: function(params) {
							if (Array.isArray(params)) {
								return params[0].name + "：" + params[0].value;
							}
							return params;
						},
					},
					xAxis: {
						type: "value",
						nameTextStyle: {
							color: "#fff",
							fontSize: 12,
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "rgba(255, 255, 255, 0.3)",
							},
						},
						axisLabel: {
							color: "#fff",
							fontSize: 12,
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "rgba(255,255,255,0.3)",
								type: 'dashed',
							},
						},
					},
					yAxis: {
						type: "category",
						data: this.arrX,
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "rgba(255, 255, 255, 0.3)",
							},
						},
						axisLabel: {
							color: "#fff",
							fontSize: 12,
							margin: 10,
							triggerEvent: true,
							formatter: this.labelFormatter
						},
						inverse: false,
					},
					series: [{
						type: "bar",
						name: this.chartName,
						barWidth: 26,
						itemStyle: {
							color: (params) => {
								// 根据索引返回颜色
								return this.getColorByIndex(params.dataIndex);
							}
						},
						label: {
							show: true,
							position: 'right',
							color: '#fff',
							fontSize: 12,
							formatter: '{c}个'
						},
						data: chartData, // 使用格式化后的数据
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}],
				};
				
				ZCcunliangzichanxingzhizhanbi.setOption(option);
				
				// 设置点击事件
				this.setupChartClick(ZCcunliangzichanxingzhizhanbi,'echarts');
				
				// 响应窗口大小变化
				window.addEventListener("resize", this.handleResize);
			},
			
			// 辅助方法：根据索引获取颜色（与饼图 PRESET_COLORS 保持一致）
			getColorByIndex(index) {
				const colors = ['#28c700', '#ff5e5e', '#ffb800', '#00d3f0', '#ab47bc', '#2196f3'];
				return colors[index % colors.length];
			},
			
			// 标签格式化方法
			labelFormatter(params) {
				var str = "";
				var paramsLen = params.length;
				var len = 4;
				var rowNumber = Math.ceil(paramsLen / len);
				
				if (paramsLen > len) {
					for (var i = 0; i < rowNumber; i++) {
						var start = i * len;
						var end = start + len;
						if (i == rowNumber - 1) {
							str += params.substring(start, paramsLen);
						} else {
							str += params.substring(start, end) + "\n";
						}
					}
				} else {
					str = params;
				}
				return str;
			}
		}
	};
</script>